$(document).ready(function() {
  
  $("body").on("click", "input[name=buyMethod]" ,function(e) {
    
    // e.preventDefault();
    // e.stopPropagation();
    var value = $(this).val();
    
    $(".rental-table-wrapper").hide();
    $(".productView-buyingMethod-Rental").hide();
    if(value === "buy"){
      // .productView-product .productView-price, 
     $(".productView-product .productView-options, .productView-product .quantity_selector, .productView-product .productView-buttons, .productView-product .productView-subtotal").show();
     $(`.productView-buyingMethod-Buy`).show(); 
    } else if(value === "rental_massage_price_table"){
      $(`#rental_massage_price_table`).show();
      $(`.productView-buyingMethod-Rental`).show();
      $(`.productView-buyingMethod-Buy`).hide(); 
    } else{
      // .productView-product .productView-price
      $(".productView-product .productView-options, .productView-product .quantity_selector, .productView-product .productView-buttons, .productView-product .productView-subtotal").hide();
      $(`.productView-buyingMethod-Rental.${value}`).show();
      $(`.productView-buyingMethod-Buy`).hide(); 
    }
  });

  // this is for old rental table that had separated visit and self install prices
  $("body").on("click", "input[name=buyMethodRental]",function(e) {

    // e.preventDefault();
    // e.stopPropagation();
    
    $(".rental-table-wrapper").hide();
    $(`#${$(this).val()}`).show();
  });
});